import { isFunction, isString } from 'lodash'
import { isMoment } from 'moment'

import { API_DATE, getTimezoneLessMoment } from '../momentjs'
import { ValidationFields } from '../validators'
import { Genders } from '../api/student'
import { LanguageLocale } from './language'
import { getIdOrNull, validateString } from '..'

/** @enum {string} */
export const StudentProperties = Object.freeze({
  EMAIL: ValidationFields.EMAIL,
  FIRSTNAME: ValidationFields.FIRSTNAME,
  LASTNAME: ValidationFields.LASTNAME,
  GENDER: ValidationFields.GENDER,
  LANGUAGE: ValidationFields.LANGUAGE,
  SECTIONS: ValidationFields.SECTIONS,
  PHONE_NUMBER: 'phoneNumber',
  BIRTHDATE: 'birthdate',
  NISS: 'niss'
})

export const StudentValidators = Object.freeze({
  [StudentProperties.EMAIL]: s => validateString(s.email, { isEmail: true }),
  [StudentProperties.LASTNAME]: s => validateString(s.lastname, { notEmpty: true }),
  [StudentProperties.FIRSTNAME]: s => validateString(s.firstname, { notEmpty: true }),
  [StudentProperties.LANGUAGE]: s => validateString(s.language, { notEmpty: true })
})

export const getStudentFullSection = student => {
  let section = 'NONE'

  if (student.sections && student.sections.length > 0 && student.sections[0].sectionToYear) {
    const { sectionToYear } = student.sections[0]

    section = `${sectionToYear.sectionAbbreviation} (${sectionToYear.schoolYearName})`
  }

  return section
}

export class Student {
  constructor ({ id = -1, birthdate = null, email = '', firstname = '', lastname = '', phoneNumber = null, gender = Genders.OTHER, language = new LanguageLocale().languageTag, sections = [], stillInSchool, niss } = {}) {
    this.id = id
    this.birthdate = isString(birthdate) ? getTimezoneLessMoment(birthdate) : birthdate
    this.email = email
    this.firstname = firstname
    this.lastname = lastname
    this.phoneNumber = phoneNumber
    this.gender = gender
    this.language = language
    this.sections = sections
    this.stillInSchool = stillInSchool
    this.niss = niss
  }

  toRequestBody = () => {
    const body = {}

    Object.entries(this).forEach(([property, value]) => {
      if (isMoment(value)) {
        body[property] = value.format(API_DATE)
      } else if (!isFunction(value)) {
        body[property] = getIdOrNull(value)
      }
    })

    return body
  }
}
